function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Button } from '../Button';
import { applyVariations } from '../utils';
var TransparentButton = styled(Button).withConfig({
  displayName: "IconButton__TransparentButton",
  componentId: "sc-4ss1z0-0"
})(["padding:0;background-color:transparent;color:inherit;&:hover{background-color:transparent;color:inherit;}& > div{display:flex;}&:disabled{background-color:transparent;}", ""], applyVariations('IconButton'));
var IconButton = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var icon = _ref.icon,
      props = _objectWithoutProperties(_ref, ["icon"]);

  return /*#__PURE__*/React.createElement(TransparentButton, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("div", null, icon));
});
IconButton.displayName = 'IconButton';
IconButton.isIconButton = true;
IconButton.propTypes = {
  icon: PropTypes.node
};
export default IconButton;